module.exports = __webpack_public_path__ + "img/logo-aliados.7bf0f046.png";